import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import './PageSelector.css'

const styles = theme => ({
    title: {
        color: theme.palette.text.primary
    },
    bigSelect: {
        ...theme.typography.display2,
        color: theme.palette.text.primary
    },
    bigSelectSelectMenu: {
        whiteSpace: 'unset'
    }
  });

class PageSelector extends Component {

    /* Handlers */

    handleSelectPage = (event) => {
        this.props.actions.pushToUrl(event.target.value)
    }

    /* Lifecycle */
     
    render() {

        const { classes } = this.props

        return (
            <div className="pages-shared-page-selector">
                <Typography className={classes.title} variant="display2" gutterBottom>
                    <strong>I numeri di IDD su&nbsp;</strong>
                    <Select
                        className={classes.bigSelect}
                        classes={{
                            selectMenu: classes.bigSelectSelectMenu
                        }}
                        value={this.props.pathname}
                        onChange={this.handleSelectPage}
                        inputProps={{
                            name: 'page',
                            id: 'page',
                        }}>
                        <MenuItem value={'/accommodations'}>le strutture ricettive</MenuItem>
                        <MenuItem value={'/guests_satisfaction'}>la soddisfazione degli ospiti</MenuItem>
                        <MenuItem value={'/tourist_source'}>gli arrivi turistici</MenuItem>
                    </Select>
                </Typography>
            </div>       
        )
    }
}

const styledPageSelector = withStyles(styles)(PageSelector)

const mapStateToProps = state => ({
    pathname: state.router.location.pathname
})

function mapDispatchToProps(dispatch) {
    return { 
        actions: {
            pushToUrl: bindActionCreators(push, dispatch)
        }
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(styledPageSelector)


// WEBPACK FOOTER //
// ./src/components/pages/shared/PageSelector.js